"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NurseStatePracticeAuthorizationCode = void 0;
exports.instanceOfNurseStatePracticeAuthorizationCode = instanceOfNurseStatePracticeAuthorizationCode;
exports.NurseStatePracticeAuthorizationCodeFromJSON = NurseStatePracticeAuthorizationCodeFromJSON;
exports.NurseStatePracticeAuthorizationCodeFromJSONTyped = NurseStatePracticeAuthorizationCodeFromJSONTyped;
exports.NurseStatePracticeAuthorizationCodeToJSON = NurseStatePracticeAuthorizationCodeToJSON;
exports.NurseStatePracticeAuthorizationCodeToJSONTyped = NurseStatePracticeAuthorizationCodeToJSONTyped;
/**
 *
 * @export
 */
exports.NurseStatePracticeAuthorizationCode = {
    Authorized: 'AUTHORIZED',
    NoAuthorization: 'NO_AUTHORIZATION',
    ContactBoardOfNursing: 'CONTACT_BOARD_OF_NURSING',
    NonParticipatingJurisdiction: 'NON_PARTICIPATING_JURISDICTION',
    AuthorizedByRemoteMultistateLicense: 'AUTHORIZED_BY_REMOTE_MULTISTATE_LICENSE',
    NoAuthorizationDueToDiscipline: 'NO_AUTHORIZATION_DUE_TO_DISCIPLINE',
    ContactBoardOfNursingRemoteState: 'CONTACT_BOARD_OF_NURSING_REMOTE_STATE'
};
function instanceOfNurseStatePracticeAuthorizationCode(value) {
    for (const key in exports.NurseStatePracticeAuthorizationCode) {
        if (Object.prototype.hasOwnProperty.call(exports.NurseStatePracticeAuthorizationCode, key)) {
            if (exports.NurseStatePracticeAuthorizationCode[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function NurseStatePracticeAuthorizationCodeFromJSON(json) {
    return NurseStatePracticeAuthorizationCodeFromJSONTyped(json, false);
}
function NurseStatePracticeAuthorizationCodeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function NurseStatePracticeAuthorizationCodeToJSON(value) {
    return value;
}
function NurseStatePracticeAuthorizationCodeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=NurseStatePracticeAuthorizationCode.js.map